import apiHandler from "../core/apiHandler";

const salesPdfApi = apiHandler('pdf/sales');
export default salesPdfApi;
